import { normalize, schema } from 'normalizr';

export const entity = 'staffEcomLanguage';
export const entitySchema = new schema.Entity(entity);
export const listNormalizer = (result) => normalize(result.shop_languages, [entitySchema]);
